import React from 'react';

const ContactForm: React.FC = () => {
  return (
    <div className="contact-form-container flex flex-col items-center justify-center pb-10 bg-dark-blue rounded-lg shadow-md max-w-lg mx-auto text-gray-300">
<h1 className="text-4xl text-center text-gray-300 mb-4 mt-4">Contact Us</h1>
      <p className="text-xl text-center text-gray-400 mb-6">
        Submit your account-related inquiries here.
      </p>
      <hr className="border-t border-gray-600 w-2/3 mb-8" />
      <p className="mb-6 font-bold">Please use this form only for account-related issues. All other inquiries will be ignored.</p>
      <p className="mb-6">For bug reports, submit a report directly in Deck Hopper by going to Menu - Help tab.</p>
      <p className="mb-6">For further assistance, you're welcome to <a href="https://discord.christinak.ca" className="text-amber-500 hover:text-amber-400 underline"> join Christina's Discord server</a> and post in <code>#deck-hopper-help</code> channel.</p>

      <form action="https://api.staticforms.xyz/submit" method="post" className="w-full">
        <input type="hidden" name="accessKey" value="724e2b70-92b6-44ff-ae60-2d70b1d8c29f" />

        <div className="mb-4">
          <label htmlFor="email" className="block  font-bold mb-2">Email:</label>
          <input type="email" id="email" name="email" placeholder="Your Email" required className="text-gray-300 bg-gray-800 border-gray-500 shadow appearance-none border rounded w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline" />
        </div>

        <div className="mb-4">
          <label htmlFor="discord" className="block  font-bold mb-2">Discord Username (optional):</label>
          <p className="text-sm">Will be used to contact you if you are a Discord user.</p>
          <input type="text" id="discord" name="$discordName" placeholder="Discord Username" className="mt-2 text-gray-300 bg-gray-800 border-gray-500 shadow appearance-none border rounded w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline" />
        </div>

        <div className="mb-4">
          <label htmlFor="account-id" className="block font-bold mb-2">Account ID:</label>
          <p className="text-sm">Find your Account ID in Menu - Account tab - Get User ID</p>
          <input type="text" id="account-id" name="$accountID" placeholder="Your Account ID" required className="mt-2 text-gray-300 bg-gray-800 border-gray-500 shadow appearance-none border rounded w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline" />
        </div>

        <div className="mb-4">
          <label htmlFor="issue-description" className="block font-bold mb-2">Issue Description:</label>
          <p className="text-sm">For Billing issues, please upload and attach a link to your Purchase receipt.</p>
          <textarea id="issue-description" name="message" placeholder="Describe your issue" required className="mt-2 text-gray-300 bg-gray-800 border-gray-500 shadow appearance-none border rounded w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"></textarea>
        </div>

        <input type="text" name="honeypot" style={{ display: 'none' }} />
        <input type="hidden" name="replyTo" value="@" />
        <input type="hidden" name="redirectTo" value="https://christinak.ca/deckhopper/contact?form=success" />

        <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-gray-300 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">Submit</button>
      </form>
    </div>
  );
};

export default ContactForm;
